<div class="spinner" [ngClass]="{'content-block': type === 'content-block' }">
  <mat-spinner [diameter]="20"></mat-spinner>
  <ng-content></ng-content>
</div>
